import React, { ReactNode } from 'react';

interface PlatformCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  isActive: boolean;
  onClick: () => void;
}

const PlatformCard: React.FC<PlatformCardProps> = ({
  title,
  description,
  icon,
  isActive,
  onClick
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        relative rounded-lg shadow-sm p-4 border transition-all duration-200 cursor-pointer
        ${isActive 
          ? 'bg-blue-50 border-blue-200 dark:bg-blue-900/30 dark:border-blue-800' 
          : 'bg-white border-gray-100 hover:border-blue-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:border-blue-900/50'
        }
      `}
    >
      {isActive && (
        <div className="absolute top-0 left-0 w-full h-1 bg-blue-500 rounded-t-lg"></div>
      )}
      <div className="flex items-start">
        <div className="p-2 bg-blue-50 dark:bg-blue-900/30 rounded-lg mr-4">
          {icon}
        </div>
        <div>
          <h3 className="text-sm font-medium text-gray-900 dark:text-white">{title}</h3>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default PlatformCard;